import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import { Breadcrumb } from "react-bootstrap";
import MeetingLayer from "./MeetingLayer";


const MeetingPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Meetings" />

        {/* MeetingLayer */}
        <MeetingLayer />

      </MasterLayout>
    </>
  );
};

export default MeetingPage;
